import { Observable } from 'rxjs';
import { ImportFileMetaData } from './import-file-metadata.model';

export class FileImportModel {
    public metaData: ImportFileMetaData;
    public importCallBack: (ImportFileMetaData) => Observable<any>;
    public reloadPage: () => any;
}
